var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_1",
    x: 0.0917969,
    width: 40,
    height: 40,
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_168424)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.2143 26.1351C19.4918 26.1351 19.7243 25.9101 19.7243 25.6251C19.7243 25.3476 19.4993 25.1151 19.2143 25.1151H11.9768C11.6993 25.1151 11.4668 25.3401 11.4668 25.6251C11.4668 25.9026 11.6918 26.1351 11.9768 26.1351H19.2143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.7243 23.7425C19.7243 24.0275 19.4918 24.2525 19.2143 24.2525H11.9768C11.6918 24.2525 11.4668 24.02 11.4668 23.7425C11.4668 23.4575 11.6993 23.2325 11.9768 23.2325H19.2143C19.4993 23.225 19.7243 23.4575 19.7243 23.7425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.2143 22.3625C19.4918 22.3625 19.7243 22.1375 19.7243 21.8525C19.7243 21.575 19.4993 21.3425 19.2143 21.3425H11.9768C11.6993 21.3425 11.4668 21.5675 11.4668 21.8525C11.4668 22.13 11.6918 22.3625 11.9768 22.3625H19.2143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.7243 19.97C19.7243 20.255 19.4918 20.48 19.2143 20.48H11.9768C11.6918 20.48 11.4668 20.2475 11.4668 19.97C11.4668 19.685 11.6993 19.46 11.9768 19.46H19.2143C19.4993 19.4525 19.7243 19.685 19.7243 19.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M19.2143 18.59C19.4918 18.59 19.7243 18.365 19.7243 18.08C19.7243 17.8025 19.4993 17.57 19.2143 17.57H11.9768C11.6993 17.57 11.4668 17.795 11.4668 18.08C11.4668 18.3575 11.6918 18.59 11.9768 18.59H19.2143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M22.9343 26.1274C23.4521 26.1274 23.8718 25.7077 23.8718 25.1899C23.8718 24.6722 23.4521 24.2524 22.9343 24.2524C22.4166 24.2524 21.9968 24.6722 21.9968 25.1899C21.9968 25.7077 22.4166 26.1274 22.9343 26.1274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M28.0569 25.1899C28.0569 25.7077 27.6371 26.1274 27.1194 26.1274C26.6016 26.1274 26.1819 25.7077 26.1819 25.1899C26.1819 24.6722 26.6016 24.2524 27.1194 24.2524C27.6371 24.2524 28.0569 24.6722 28.0569 25.1899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M21.9293 17.195C21.2272 17.195 20.6543 17.7679 20.6543 18.47V22.0925C20.6543 22.7946 21.2272 23.3675 21.9293 23.3675H27.8318C28.5339 23.3675 29.1068 22.7946 29.1068 22.0925V18.47C29.1068 17.7679 28.5339 17.195 27.8318 17.195H21.9293ZM22.4093 20.465C22.4093 20.1425 22.6718 19.8725 23.0018 19.8725C23.3318 19.8725 23.5943 20.1425 23.6018 20.465V22.6175H22.4093V20.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_1_i",
    d: "M14.0601 14.0774L26.5585 11.6171C26.6589 11.261 26.9861 11 27.3744 11C27.4123 11 27.4498 11.0025 27.4864 11.0073C27.5209 11.0025 27.556 11 27.5918 11C28.006 11 28.3418 11.3358 28.3418 11.75C28.3418 11.9795 28.2387 12.1849 28.0763 12.3225C27.9239 12.5473 27.6664 12.695 27.3744 12.695C27.0965 12.695 26.8498 12.5613 26.6953 12.3546L15.25 14.6075H28.6268C30.1295 14.6075 31.339 15.8207 31.3493 17.3174L31.3493 17.3225L31.3493 26.5175C31.3493 28.0193 30.1285 29.24 28.6268 29.24H28.2593V29.2775C28.2593 29.8475 27.7943 30.305 27.2318 30.305C26.6618 30.305 26.2043 29.8475 26.2043 29.2775V29.24H13.8968V29.2775C13.8968 29.8475 13.4393 30.305 12.8693 30.305C12.2993 30.305 11.8418 29.8475 11.8418 29.2775V29.24H11.5643C10.0626 29.24 8.8418 28.0193 8.8418 26.5175V17.33C8.8418 15.8283 10.0626 14.6075 11.5643 14.6075H11.8879C12.1503 14.142 12.6493 13.8275 13.2218 13.8275C13.5313 13.8275 13.8193 13.9194 14.0601 14.0774ZM11.888 16.1075H11.5643C10.891 16.1075 10.3418 16.6568 10.3418 17.33V26.5175C10.3418 27.1908 10.891 27.74 11.5643 27.74H28.6268C29.3001 27.74 29.8493 27.1908 29.8493 26.5175V17.3255C29.8434 16.6482 29.2984 16.1075 28.6268 16.1075H14.5557C14.2933 16.5731 13.7943 16.8875 13.2218 16.8875C12.6494 16.8875 12.1503 16.5731 11.888 16.1075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_168424"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext3_1_i",
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.0918 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/Radio.3f9783ae.svg";
export { ForwardRef as ReactComponent };